import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import instance from "../../../common/api/interceptor";
import { path } from "../../../constants/apiPath";
import Card from "../../dashboard/card/Card";
import Loading from "../../loading/Loading";
import { StoreContext } from "../../../store";
import routeConstant from "../../../../route/compoent/routeConstant";
import { NotificationManager } from "react-notifications";
import { useOutletContext } from "react-router-dom";
import { TabPanel } from "@mui/lab";
import { OrderContext } from "../store";
import NoData from "../../noData/NoData";
import InfiniteScroll from "react-infinite-scroller";
import { CircularProgress } from "@mui/material";
import { StoreContext as MtsStore } from "../../../../store/Provider";

function ShippedOrder() {
  const [loading, setLoading] = useState(false);
  const [outletContextTabValue, orderDetailsCardClick, buyerSelected] =
    useOutletContext();
  const pageSize = 10;
  const navigate = useNavigate();
  const context = useContext(StoreContext);
  const { shippedData, setShippedData, orderDetails, setOrderDetails } =
    useContext(OrderContext);
  const { notificationOpen } = useContext(MtsStore);
  const [isMount, setIsMount] = useState(false);

  useEffect(() => {
    setIsMount(true);
    if (shippedData.data.length === 0) {
      getBuyerOrderData(0, pageSize);
    }
  }, [buyerSelected]);

  useEffect(() => {
    if (shippedData.data.length === 0 && isMount) {
      getBuyerOrderData(0, pageSize);
    }
  }, [notificationOpen]);

  const onLoadMore = () => {
    console.log("loadmore called", shippedData);
    if (shippedData.hasMore) {
      const page = shippedData.page + 1;
      getBuyerOrderData(page, pageSize);
    }
  };

  const getBuyerOrderData = (page, pageSize) => {
    if (!page) setLoading(true);
    let body = {
      SearchData: "",
      OrgCodes: buyerSelected,
      Status: "SHP",
      SortColumnName: "OD_OrderLastEditedDateUTC",
      SortDirection: "desc",
      CurrentPage: page,
      PageSize: pageSize,
    };
    instance
      .post(path.SEARCH_ORDER, body)
      .then((res) => {
        if (!page) setLoading(false);
        if (res.Is_Success) {
          setShippedData({
            ...shippedData,
            page: page,
            hasMore: res?.data?.OrderHeader?.length === pageSize,
            data: [...shippedData.data, ...(res?.data?.OrderHeader ?? [])],
          });
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  const onEdit = (orderPK) => {
    context.setBackDropOpen(true);
    instance
      .get(`api/v1/Order/editOrder?orderPk=${orderPK}`)
      .then((res) => {
        if (res.Is_Success) {
          context.setEditOrderJSON(res.data ?? {});
          context.setEditMode(true);
          navigate(routeConstant.LIST_EDIT_CREATE_ORDER, {
            state: { edit: true, editOrderJSON: res.data },
          });
        } else {
          NotificationManager.error(res.Message, "", 3000);
        }
        context.setBackDropOpen(false);
      })
      .catch((err) => {
        console.error(err);
        if (err.response) {
          NotificationManager.error(err.response.data.Message, "", 3000);
        } else if (err.request) {
        } else if (err.message) {
        } else {
          NotificationManager.error("Something went wrong!", "", 3000);
        }
        context.setBackDropOpen(false);
      });
  };

  const onCardHandler = (orderPk) => {
    context.setBackDropOpen(true);

    instance
      .get(`${path.GET_ORDER_DETAIL}?orderPk=${orderPk}`)
      .then((res) => {
        context.setBackDropOpen(false);
        setOrderDetails(res.data);
      })
      .catch((err) => {
        context.setBackDropOpen(false);
        console.log(err);
      });
  };

  return (
    <TabPanel
      className={`_orderListTabPanelDiv _orderListTabPanelDiv${2}`}
      value={outletContextTabValue}
      index={2}
    >
      <InfiniteScroll
        className="infiniteScroller"
        pageStart={0}
        loadMore={onLoadMore}
        hasMore={shippedData.hasMore}
        loader={
          <div className="bottomLoader">
            <CircularProgress size="1.5rem" />
          </div>
        }
        useWindow={false}
      >
        {loading ? (
          <Loading />
        ) : shippedData.data.length === 0 ? (
          <NoData>
            <p>No order found!</p>
          </NoData>
        ) : (
          shippedData.data.map((ele) => {
            return (
              <div
                className={
                  ele.OrderPK === orderDetails?.OrderHeader?.OrderPK
                    ? "_dashboardCardBody _activeLoadedCard"
                    : "_dashboardCardBody"
                }
                onClick={() => {
                  onCardHandler(ele.OrderPK);
                  orderDetailsCardClick(ele);
                }}
              >
                <Card data={ele} onEdit={onEdit} />
              </div>
            );
          })
        )}
      </InfiniteScroll>
    </TabPanel>
  );
}

export default ShippedOrder;
